import { SCOPES } from '../api';
import type { NavNode } from '@nyce/admin-kit/console';

/** The NYCE Design group's pages (children of its node in `NAV`). */
export const DESIGN_NAV: NavNode[] = [
  {
    path: '/design/tenants',
    label: 'Tenants',
    requires: SCOPES.designRead,
    description: 'Which AUTH tenants may use NYCE Design: sign-in code, enabled, single sign-on, usage.',
  },
];
